<select
  [compareWith]="compareReferencias"
  bootstrapSelect
  [(ngModel)]="selectedReferencias"
  [class]="customClasses"
  [title]="customTitle"
  [maxOptions]="maxOptions"
  [size]="customWidth"
  [disabled]="disabled"
>
  <ng-container *ngIf="referencias.length === 0; else opcionesDisponibles">
    <option value="" disabled><span class="mensaje-dropDown-resultados">No se han encontrado resultados. <br> <strong> Selecciona un cliente para obtener registros</strong>.</span></option>
  </ng-container>
  <ng-template #opcionesDisponibles>
    <option
      *ngFor="let referencia of referencias"
      [ngValue]="referencia"
      id="{{ referencia.Id }}">
      {{ referencia.Nombre }}
    </option>
  </ng-template>

</select>
